<template>
  <p @click="openModal" :style="{ 'background-color': getBackgroundColor() }" class="btn status_color_text">{{ payload.status }}</p>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
  props: {
    payload: {
      type: Object,
      default: () => {}
    }
  },
  name: 'status-color',
  methods: {
    openModal () {
      this.create({ designator: 'position-status-modal', component_name: 'PositionStatusForm', position_data: this.payload, modal_title: 'Change Position Status' })
    },
    getBackgroundColor () {
      if (this.payload.status == 'active') {
        return 'green'
      }
      if (this.payload.status == 'editing') {
        return 'darkorange'
      }
      return '#c9302c'
    },
    ...mapMutations('modals', ['create'])
  }
}
</script>
